import { render, staticRenderFns } from "./Tlpf.vue?vue&type=template&id=14e8aaa7&"
import script from "./Tlpf.vue?vue&type=script&lang=ts&"
export * from "./Tlpf.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports